export default __webpack_public_path__ + "static/media/easyOfAdoption.fe90cc53.png";